import React, { useCallback } from "react";
import { Form, Checkbox, Tooltip } from "antd";
import { get } from 'lodash';

const CheckboxInput = ({
  values,
  errors,
  handleSubmit,
  setFieldValue,
  setFieldTouched,
  name,
  label,
  formItemLayout,
  readOnly,
  ccsClass,
  callback,
  tooltip
}) => (
  <Form.Item label={label} {...formItemLayout}
    hasFeedback={!!get(errors, name)}
    validateStatus={get(errors, name) && "error"}
    help={get(errors, name)}
  >
    {tooltip &&
      <Tooltip title={tooltip}>
        <Checkbox style={{ paddingTop: 5 }}
          checked={get(values, name)}
          onChange={event => {
            setFieldValue(name, event.target.checked);
            if (callback) {
              callback(event.target.checked);
            }
          }}
          onBlur={() => setFieldTouched(name)}
          disabled={readOnly}
        />
      </Tooltip>
    }
    {!tooltip &&
      <Checkbox style={{ paddingTop: 5 }}
        checked={get(values, name)}
        onChange={event => {
          setFieldValue(name, event.target.checked);
          if (callback) {
            callback(event.target.checked);
          }
        }}
        onBlur={() => setFieldTouched(name)}
        disabled={readOnly}
      >&nbsp;&nbsp;</Checkbox>
    }
  </Form.Item>
);

export default CheckboxInput;
